/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'traffic-logs-search-bar-dropdown';
const prefix = `${moduleName}.${componentName}`;

export const noOptionsMessage = `${prefix}.noOptionsMessage`;
export const errorMessage = `${prefix}.errorMessage`;

export const ENGLISH = {
    [noOptionsMessage]: 'no logs with this property',
    [errorMessage]: 'unable to load suggestions',
};
